import { FC, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Radio } from 'antd';

import { BoardContext, TeamContext } from "../../../context";
import { MainButton } from "../../atoms";

import "antd/dist/antd.css";
import { useSound } from "../../../hooks";
import { useTranslation } from "react-i18next";



const PostMatchSurveyMolecule: FC<{}> = () => {
    const { t } = useTranslation();
    const { setisGameInPostGamePhase } = useContext(BoardContext);
    const { urlToken, gameId } = useContext(TeamContext);

    const [mostSignificatntThing, setMostSignificatntThing] = useState<string>("");

    const [questionOne, setQuestionOne] = useState<number>(1);
    const [questionTwo, setQuestionTwo] = useState<number>(1);
    const [questionThree, setQuestionThree] = useState<number>(1);
    const {playSound, stopSound} = useSound();
    let history = useHistory();

    const windowLocationPathname = window.location.pathname.substring(1);
    const urlTokenExtracted = windowLocationPathname.substr(windowLocationPathname.length - 36);

    const handleChange = (type: string, event: any) => {
        if (type === "mostSignificatntThing")
            setMostSignificatntThing(event.target.value);
    }

    const handleSubmit = () => {
        stopSound();
        sendSurveyDataToBack();
        redirectToGoodbyePage();
    }

    const redirectToGoodbyePage = () => {
        history.push( "/goodbye/" + urlToken);  
    }

    const sendSurveyDataToBack = () => {
        let data = {
            matchId: urlTokenExtracted,
            gameEnjoy: questionOne,
            practicalTools: questionTwo,
            recommendToFriend: questionThree,
            description: mostSignificatntThing
        }

        fetch(process.env.REACT_APP_BACKEND_URL + "api/post-games/survey", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(() => {
                setisGameInPostGamePhase(true);
            })
            .catch((err) => {
                console.error(err);
            });
    }


    return (
        <form onSubmit={handleSubmit}>
            <div className="form_section_wrapper">
                <div>
                    <label> {t("howMuchDidYouEnjoyTheGameText")} </label>
                </div>
                <div className="radio_wrapper">
                    <Radio.Group onChange={(event) => setQuestionOne(event.target.value)} value={questionOne}>
                        {Array.apply(null, Array(10)).map(function (_x, i) { return <Radio key={i + 1} value={i + 1}>{i + 1}</Radio> })}
                    </Radio.Group>
                </div>
            </div>

            <div className="form_section_wrapper">
                <div>
                    <label> {t("howMuchDidYouFeelYouWereGivenPracticalToolsText")} </label>
                </div>
                <div className="radio_wrapper">
                    <Radio.Group onChange={(event) => setQuestionTwo(event.target.value)} value={questionTwo}>
                        {Array.apply(null, Array(10)).map(function (_x, i) { return <Radio key={i + 1} value={i + 1}>{i + 1}</Radio> })}
                    </Radio.Group>
                </div>
            </div>

            <div className="form_section_wrapper">
                <div>
                    <label> {t("howLikelyAreYouToRecommendThisGameToAFriendText")} </label>
                </div>
                <div className="radio_wrapper">
                    <Radio.Group onChange={(event) => setQuestionThree(event.target.value)} value={questionThree}>
                        {Array.apply(null, Array(10)).map(function (_x, i) { return <Radio key={i + 1} value={i + 1}>{i + 1}</Radio> })}
                    </Radio.Group>
                </div>
            </div>

            <div className="form_section_wrapper">
                <div style={{ paddingBottom: '20px' }}>
                    <label> {t("weWouldBeUppyToHearYourThougtsText")}: </label>
                </div>
                <textarea
                    value={mostSignificatntThing}
                    onChange={(event) => handleChange("mostSignificatntThing", event)}
                    placeholder={t("pleaseEnterAtLeast2SentencesText")}
                    cols={30}
                    rows={5}
                />
            </div>
            <div style={{ width: '30%', margin: '15px auto 0' }}>
                <MainButton text={t("sendText")} type="big" clickHandler={() => handleSubmit()} />
            </div>
        </form>
    );
};

export default PostMatchSurveyMolecule;
